import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseTefProductCodesProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    companyId?: string;
    provider?: string;
    productCategoryId?: string;
  };
  mapper?: (data: any) => T;
}

export const useTefProductCodes = <T,>({
  filters: { search = '', page, companyId, provider, productCategoryId } = {},
  mapper = Mapper.default<T>(),
}: UseTefProductCodesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['tefProductCodes', search, page, companyId, provider, productCategoryId],
    queryFn: () => privateAxios.get('/establishment/tef_product_codes', {
      params: {
        search,
        page,
        'q[company_id_eq]': companyId,
        'q[provider_eq]': provider,
        'q[product_category_id_eq]': productCategoryId,
      },
    }),
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
}
